let Language = {
  PORTUGUESE: { id: 1, name: 'Português', symbol: "Pt" },
  ENGLISH: { id: 2, name: 'English', symbol: "En" },
  SPANISH: { id: 3, name: 'Español', symbol: "Sp" },
};

export default Language;
export const languages = Object.keys(Language).map(key => Language[key]);



// WEBPACK FOOTER //
// ./src/enums/Language.js